
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 25.534"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"a",attrs:{"d":"M12.44 0a2.389 2.389 0 00-2.312 2.454 2.389 2.389 0 002.312 2.454 2.389 2.389 0 002.312-2.454A2.389 2.389 0 0012.44 0zM8.51 4.908s-3.251.165-3.558.185a.889.889 0 00-.665.276c-.17.18-2.894 3.382-3.179 3.712A.7.7 0 00.79 9.02a.76.76 0 00-.668.656.8.8 0 00.437.847l16.039 8.5c-.462.732-.889 1.227-1.358 1.227-.52 0-.943.1-1.127.522-.275.633-2.139 4.755-2.139 4.755H24s-3.338-7.516-3.67-8.344c-.376-.936-.834-1.473-1.272-1.473s-.712.3-1.676 1.994l-3.815-2.025c-.246-1.223-1.3-7.424-1.3-7.424a1.994 1.994 0 00-.376-.951A6.722 6.722 0 0010.36 5.89c-1.131-.821-1.532-.982-1.821-.982zM6.169 7.516a114.253 114.253 0 01-2.023 3.16L2.759 9.94l2.225-2.363zm4.364 2.761c.376 1.622.831 3.578 1.04 4.356l-3.034-1.626zm-7.572 2.915S.158 23.208.071 23.561s-.271 1.526.751 1.9c1.084.4 1.387-1.012 1.387-1.012l2.861-8.038 2.63 2.577.607 5.246s.033 1.288 1.011 1.288.983-.679.983-1.534c0-.763-.159-4.326-.173-4.632a2.343 2.343 0 00-.231-.89c-.275-.5-1.185-2.209-1.185-2.209z"}})])
          )
        }
      }
    